export enum ShipmentAction {
  ADD_TAGS = 'ADD_TAGS',
  ASSIGN_USERS = 'ASSIGN_USERS',
  CANCEL = 'CANCEL',
  CANCEL_CHECK_CALL_EMAILS = 'CANCEL_CHECK_CALL_EMAILS',
  CANCEL_WATERFALL_TENDER = 'CANCEL_WATERFALL_TENDER',
  CARRIER_UNASSIGN = 'CARRIER_UNASSIGN',
  CONSOLIDATE = 'CONSOLIDATE',
  EMAIL_DOCUMENTS = 'EMAIL_DOCUMENTS',
  EVENT_DELIVERED_CREATE = 'EVENT_DELIVERED_CREATE',
  EVENT_DELIVERED_UNDO = 'EVENT_DELIVERED_UNDO',
  EVENT_MISC_CREATE = 'EVENT_MISC_CREATE',
  EVENT_PICKUP_CREATE = 'EVENT_PICKUP_CREATE',
  EVENT_PICKUP_UNDO = 'EVENT_PICKUP_UNDO',
  EVENT_SERVICE_FAILURE_CREATE = 'EVENT_SERVICE_FAILURE_CREATE',
  INITIATE_MACROPOINT_TRACKING = 'INITIATE_MACROPOINT_TRACKING',
  PRINT_BOL = 'PRINT_BOL',
  PRINT_SHIPPING_LABEL_MODAL = 'PRINT_SHIPPING_LABELS_MODAL',
  CARGO_INSURANCE_CANCEL = 'CARGO_INSURANCE_CANCEL',
  CARGO_INSURANCE_PURCHASE = 'CARGO_INSURANCE_PURCHASE',
  REMOVE_ORDERS = 'REMOVE_ORDERS',
  REQUEST_DOCUMENTS = 'REQUEST_DOCUMENTS',
  REQUEST_SPOT_MARKET_BID = 'REQUEST_SPOT_MARKET_BID',
  REQUEST_TRACKING = 'REQUEST_TRACKING',
  RESEND_CONFIRMATION = 'RESEND_CONFIRMATION',
  SEND_CHECK_CALL_REQUEST = 'SEND_CHECK_CALL_REQUEST',
  SEND_TO_ROUTE_BUILDER = 'SEND_TO_ROUTE_BUILDER',
  SEND_TO_SHIPMENT_BUILDER = 'SEND_TO_SHIPMENT_BUILDER',
  SHARE = 'SHARE',
  TENDER_CONFIRM = 'TENDER_CONFIRM',
  TENDER_REJECT = 'TENDER_REJECT',
  TENDER_RESEND = 'TENDER_RESEND',
  TENDER_TO_CARRIER = 'TENDER_TO_CARRIER',
  UPDATE_HEALTH = 'UPDATE_HEALTH',
  WATERFALL_TENDER = 'WATERFALL_TENDER',
}
